module.exports = __webpack_public_path__ + "static/img/联系方式.59849b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/联系方式.png
// module id = Bq5K
// module chunks = 6